import { trackAdsBannerTeaserEvent } from './analytics';
import { normalizePage } from './utils';
import { TAnalyticsMessagePayload } from '../../types';

const EVENT_NAMES = ['show_card'];
const MARTECH_BANNER_SOURCES = ['adfox', 'internal'];

export function teaserHandler([, eventParams]: TAnalyticsMessagePayload, pageRaw: unknown) {
  const { sc, product, page: eventPage } = eventParams;

  const page = normalizePage(pageRaw);

  if (eventPage?.extra) {
    page.extra = {
      ...page.extra,
      ...eventPage.extra,
    };
  }

  switch (true) {
    // Для рекламных баннеров всю аналитику нужно отправить
    case !!product && !!product.extra && MARTECH_BANNER_SOURCES.includes(product.extra.bannerSource):
    case EVENT_NAMES.includes(product.name): {
      trackAdsBannerTeaserEvent({ sc, product, page });
      break;
    }
  }
}
